<template>
  <div v-if="status" :class="status.name" class="wrap">{{ status.display_name }}</div>
</template>

<script>
export default {
  name: 'PayoutStatus',
  props: {
    status: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>

.wrap {
  padding: 8px 16px;
  border-radius: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
}

.new {
  background-color: #C3DBFF;
}

.sent {
  background-color: #FFF3CD;
}

.paid {
  background-color: #C3E6CB;
}
</style>
